/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Horizontal_PullInputs */

const en_us2_catalog_movement_horizontal_pull = /** @type {(inputs: Catalog_Movement_Horizontal_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`horizontal pull`)
};

const pt_br2_catalog_movement_horizontal_pull = /** @type {(inputs: Catalog_Movement_Horizontal_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`puxada horizontal`)
};

const es_419_catalog_movement_horizontal_pull = /** @type {(inputs: Catalog_Movement_Horizontal_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jalón horizontal`)
};

const pt_pt2_catalog_movement_horizontal_pull = /** @type {(inputs: Catalog_Movement_Horizontal_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`puxada horizontal`)
};

const fr_fr2_catalog_movement_horizontal_pull = /** @type {(inputs: Catalog_Movement_Horizontal_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tirage horizontal`)
};

const de_de2_catalog_movement_horizontal_pull = /** @type {(inputs: Catalog_Movement_Horizontal_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`horizontales Ziehen`)
};

const it_it2_catalog_movement_horizontal_pull = /** @type {(inputs: Catalog_Movement_Horizontal_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tirata orizzontale`)
};

/**
* | output |
* | --- |
* | "horizontal pull" |
*
* @param {Catalog_Movement_Horizontal_PullInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_horizontal_pull = /** @type {((inputs?: Catalog_Movement_Horizontal_PullInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Horizontal_PullInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_horizontal_pull(inputs)
	if (locale === "es-419") return es_419_catalog_movement_horizontal_pull(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_horizontal_pull(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_horizontal_pull(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_horizontal_pull(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_horizontal_pull(inputs)
	return en_us2_catalog_movement_horizontal_pull(inputs)
});
export { catalog_movement_horizontal_pull as "catalog.movement.horizontal_pull" }